import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './LocalizedApp';
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';
// import { projectConfigurationPath } from './const';
import languageCodes, { englishCode } from './Utilities/LanguageCodes';
import Cookies from 'universal-cookie';
import { ClientProvider } from './Client';
import 'react-bootstrap';
// use custom/htmlflx for CSS
import '@popperjs/core';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/CSS/bootstrap/3.3.5/css/bootstrap.css';
import $ from 'jquery';
// import 'bootstrap/dist/js/bootstrap.js';
import '../src/CSS/bootstrap/custom/html5flx/v1/css/custom.css';
import '../src/CSS/bootstrap/custom/html5flx/v1/css/custom-body.css';
import '../src/CSS/bootstrap/custom/html5flx/v1/css/custom-body-local.css';
import '../src/CSS/ContainerPreview.css';

// import '../src/CSS/bootstrap/custom/html5flx/v1/js/responsiveness.js';

// Global jQuery Setup
declare global {
  interface Window {
    $: typeof $;
    jQuery: typeof $;
  }
}

window.$ = $;
window.jQuery = $;

const cookies = new Cookies(document.cookie);
const cookiesLang = cookies.get('lang');
const lang = languageCodes.includes(cookiesLang) ? cookiesLang : englishCode;

const AppWrapper = () => {
  // let Moodle know we're ready
  React.useEffect(() => {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({ type: 'handshake', ready: true }, '*');
    }
  }, []);

  return (
    <ClientProvider>
      <Router>
        <Routes>
          {/* <Route path={projectConfigurationPath} element={<Configuration />} /> */}
          {languageCodes.map(value => (
            <Route
              key={value}
              path={`/${value.toLowerCase()}/*`}
              element={<App />}
            />
          ))}{' '}
          <Route
            path="/"
            element={<Navigate to={`/${lang.toLowerCase()}`} />}
          />
          <Route
            path="*"
            element={<Navigate to={`/${lang.toLowerCase()}/404`} />}
          />{' '}
        </Routes>
      </Router>
    </ClientProvider>
  );
};

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<AppWrapper />);
